import { Typography } from 'design-system/src/components/Typography/Typography';
import { getEhrIntegrationDescription } from './utils';

export type InstructionsTitleProps = {
  /**
   * The display name of the EHR
   */
  ehrDisplayName: string;
  /**
   * Optional custom title text. If not provided, defaults to "Connect with {ehrDisplayName}"
   */
  titleText?: string | null;
};

/**
 * Component for displaying the title and description of EHR integration instructions
 */
export const InstructionsTitle = ({ ehrDisplayName, titleText }: InstructionsTitleProps) => {
  const title = titleText ?? `Connect with ${ehrDisplayName}`;

  return (
    <div className="flex flex-col gap-4">
      <Typography styledAs="bodyLargeDMSans" weight={600} renderedAs="h2">
        {title}
      </Typography>
      <Typography>{getEhrIntegrationDescription(ehrDisplayName)}</Typography>
    </div>
  );
};
